import Appointment from './container/Appointment'

export default Appointment;


// WEBPACK FOOTER //
// ./src/views/Appointment/index.js